









































































































import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import {JLocation, TerminalLocation, TerminalLocationArea, TerminalLocationGeofence} from "../../modules/models";
import Api from "./Api";
import UserRequired from "../UserRequired";
import {initVueGoogleMaps} from "@/modules/maps";
import Areamap from "@/components/location/Areamap.vue";
import {Area, Drawingmethod} from "@/modules/mapmodels";
import CircleIcon from "@/components/location/CircleIcon.vue";
import PolygonIcon from "@/components/location/PolygonIcon.vue";
import InfoBtn from "@/components/shared/InfoBtn.vue";
import InfoDialog from "@/components/InfoDialog.vue";
import rd from "@/modules/vRoutedefs";
import {MaxGeofenceCountPerLocation, WarningColor} from "@/modules/constants";

initVueGoogleMaps();

@Component({
    components: {
        "at-areamap": Areamap,
        "at-circle-icon": CircleIcon,
        "at-poly-icon": PolygonIcon,
        "at-info-btn": InfoBtn,
        "at-info-dialog": InfoDialog,
    }
})
export default class Areadefinition extends UserRequired {
    @Inject()
    api!: Api;

    @Prop()
    terminalLocation!: TerminalLocation;

    @Prop({default: () => []})
    terminalPoints!: JLocation[];

    focusedArea: Area | null = null;

    locationAreas: TerminalLocationArea[] = []; // Defined areas
    showLocationFences = false;
    showLocationFencesInfo = false;
    locationFences: TerminalLocationGeofence[] = [];

    removeArea(removeIdx) {
        const toRemove = this.locationAreas[removeIdx];
        this.locationAreas = this.locationAreas.filter((v, idx) => idx != removeIdx);
        this.onMapDeletedArea();
    }
    showExpanded = false;

    mapEnabled = false;

    editable = false;

    mapAreas: Area[] = [];

    dirty = false; // True when component state is different from saved state

    readonly drawingmethodCircle = Drawingmethod.CIRCLE;
    readonly drawingmethodPolygon = Drawingmethod.POLYGON;
    drawingmethod: Drawingmethod | null = null;

    get isEditing() {
        return this.editable;
    }

    get locationEditAllowed() {
        return this.mapEnabled && (
            this.user.isCompanyAdmin(this.terminalLocation.companyOrgNum) ||
            this.user.isLocationAdmin(this.terminalLocation.companyOrgNum, this.terminalLocation.id)
        );
    }

    regreminderDocTo() {
        return {path: rd.docs.regreminder.path};
    }

    drawCircle() {
        if(this.drawingmethod !== Drawingmethod.CIRCLE) {
            this.drawingmethod = Drawingmethod.CIRCLE;
            if(!this.isEditing) {
                this.enableDrawing();
            }
        } else {
            this.editable = !this.editable;
        }
    }
    drawPolygon() {
        if(this.drawingmethod !== Drawingmethod.POLYGON) {
            this.drawingmethod = Drawingmethod.POLYGON;
            if(!this.isEditing) {
                this.enableDrawing();
            }
        } else {
            this.editable = !this.editable;
        }
    }

    enableDrawing() {
        this.showExpanded = true;
        this.editable = true;
    }

    disableEditing() {
        this.editable = false;
    }

    async cancel() {
        this.disableEditing();
        await this.load(); // Reload saved state
    }

    working = false;
    async save() {
        this.working = true;
        try {
            // Convert geo entities to TerminalLocationArea the server can save
            await this.api.saveTerminalLocationAreas(this.terminalLocation.id, this.locationAreas);
            this.disableEditing();
            this.locationFences = await this.api.fetchTerminalLocationGeofences(this.terminalLocation.id);
            this.dirty = false;
        } finally {
            this.working = false;
        }
    }

    initLoaded = false;
    async load() {
        if(this.terminalLocation.id > 0) {
            this.locationAreas = await this.api.fetchTerminalLocationAreas(this.terminalLocation.id);
            this.locationFences = await this.api.fetchTerminalLocationGeofences(this.terminalLocation.id);
        }
        this.initLoaded = true;
        this.dirty = false;
    }

    get showNoAreaWarning() {
        return this.initLoaded && this.terminalLocation.regWithoutTerminal && this.terminalLocation.mobileRegGeoRequired && this.locationAreas.length === 0;
    }

    get regreminderUnavailableTooMany() {
        return this.initLoaded && this.locationAreas.length > MaxGeofenceCountPerLocation;
    }

    get regreminderUnavailable0() {
        return this.initLoaded && !this.terminalLocation.mobileRegGeoRequired && this.locationAreas.length == 0;
    }

    toggleLocationFencesInfo() {
        this.showLocationFencesInfo = !this.showLocationFencesInfo;
    }

    // Run when user removes area from map inside Areamap
    onMapDeletedArea() {
        this.emitSnack(`Område fjernet. Trykk lagre for å gjøre endring permanent`, "info");
        this.dirty = true;
    }
    // Run when user adds area from map inside Areamap
    onMapAddedArea() {
        if(this.locationAreas.length > MaxGeofenceCountPerLocation) {
            this.emitSnack(`Mer enn ${MaxGeofenceCountPerLocation} områder på anlegget. Registreringspåminnelse vil ikke vere tilgjengelig.`, WarningColor);
        } else {
            this.emitSnack(`Område lagt til. Trykk lagre for å gjøre endring permanent`, "info");
        }
        this.dirty = true;
        this.disableEditing();
    }

    @Watch("terminalLocation", {immediate: true})
    onTerminalLocationChange(nVal: TerminalLocation | null, oVal:TerminalLocation | null) {
        if(nVal != null) {
            if(oVal == null || nVal.id !== oVal.id) {
                this.load();
            }
        } else {
            this.locationAreas = [];
        }
    }
}
